import i18n from "../i18n";

function getMentorshipActionsStatsByVersionId(actions) {
  const statsByVersionId = new Map();
  if (!actions) {
    return null;
  }

  for (const assignedVersion of actions.assignedVersions) {
    const stats = {
      contentLength: assignedVersion.content.length,
      assignedCount: 0,
      approvedCount: 0,
      confirmedCount: 0,
    };

    for (const content of assignedVersion.content) {
      for (const signature of content.signatures) {
        if (getSignatureRevoke(signature)) {
          continue;
        }
        if (signature.type === "confirm") {
          stats.confirmedCount++;
          continue;
        }

        if (signature.type === "approve") {
          stats.approvedCount++;
          continue;
        }

        if (signature.type === "assign") {
          stats.assignedCount++;
          continue;
        }
      }
    }

    statsByVersionId.set(assignedVersion.id, stats);
  }

  return statsByVersionId;
}

function getMentorshipActionsStats(actions) {
  const mentorshipActionsStatsByVersionId = getMentorshipActionsStatsByVersionId(
    actions
  );

  if (!mentorshipActionsStatsByVersionId) {
    return null;
  }

  const stats = {
    assignedCount: 0,
    approvedCount: 0,
    confirmedCount: 0,
    isAllConfirmed: false,
    contentLength: 0,
  };

  if (mentorshipActionsStatsByVersionId.size === 1) {
    // eslint-disable-next-line no-unused-vars
    for (const [_, value] of mentorshipActionsStatsByVersionId) {
      stats.assignedCount += value.assignedCount;
      stats.approvedCount += value.approvedCount;
      stats.confirmedCount += value.confirmedCount;
      stats.contentLength += value.contentLength;
    }

    let isAllAssigned = true;
    // eslint-disable-next-line no-unused-vars
    for (const [_, value] of mentorshipActionsStatsByVersionId) {
      if (value.assignedCount < value.contentLength) {
        isAllAssigned = false;
        break;
      }
    }

    if (isAllAssigned && stats.assignedCount == stats.confirmedCount) {
      stats.isAllConfirmed = true;
    }
  } else {
    // eslint-disable-next-line no-unused-vars
    for (const [_, value] of mentorshipActionsStatsByVersionId) {
      stats.assignedCount += value.assignedCount;
      stats.approvedCount += value.approvedCount;
      stats.confirmedCount += value.confirmedCount;
    }

    if (
      stats.assignedCount > 0 &&
      stats.assignedCount == stats.confirmedCount
    ) {
      stats.isAllConfirmed = true;
    }

    stats.contentLength = stats.assignedCount;
  }

  return stats;
}

function getSignatureRevoke(signature) {
  return (
    signature &&
    signature.signatures &&
    signature.signatures.find((s) => s.type === "revoke")
  );
}

function getTagText(tag) {
  // vue selects empty object from dropdown transition
  if (!tag.category) {
    return "";
  }

  let text = `${i18n.t("tags." + tag.category)} | ${tag.name}`;

  if (tag.description) {
    text += ` | ${tag.description}`;
  }

  return text;
}

function getMentor(signatures) {
  if (!signatures || signatures.length == 0) {
    return null;
  }

  for (const signature of signatures) {
    if (signature.type == "assign" && !getSignatureRevoke(signature)) {
      return signature.mentor;
    }
  }

  return null;
}

// confirm can be revoked
function getLastSignature(signatures, revStatuses) {
  if (!signatures || signatures.length == 0) {
    return null;
  }
  for (const status of revStatuses) {
    const typeSignatures = signatures.filter((s) => s.type === status);
    for (const signature of typeSignatures) {
      if (!signature) continue;
      const revoke = getSignatureRevoke(signature);
      if (revStatuses.length == 5 && signature.type === "confirm" && revoke) {
        signature.revoke = revoke;
        return signature;
      }
      if (!revoke) {
        return signature;
      }
    }
  }
  return null;
}

function getNext(status, revStatuses) {
  const i = revStatuses.indexOf(status);
  return i > 0 ? revStatuses[i - 1] : null;
}

function getSignature(signatures, status) {
  if (!signatures || signatures.length == 0) {
    return null;
  }

  const signature = signatures.find(
    (s) => s.type === status && !getSignatureRevoke(s)
  );
  return signature || null;
}

function getSignatureState(signatures, revStatuses) {
  const signature = getLastSignature(signatures, revStatuses);
  const status = signature && signature.type;
  const next = (status && getNext(status, revStatuses)) || null;

  return {
    signature,
    status,
    next,
  };
}

function getSignatureDerivedData(signatures) {
  const mentor = getMentor(signatures);
  const approveSignature = getSignature(signatures, "approve");
  const confirmSignature = getSignature(signatures, "confirm");
  return {
    mentor,
    approveSignature,
    confirmSignature,
  };
}

function matchesUserOrOldID(me, idToMatch, myOldAccounts) {
  if (!me) {
    return false;
  }

  const oldAccountIds = (myOldAccounts || []).map((account) =>
    Number(account.id)
  );

  return me.id == idToMatch || oldAccountIds.includes(idToMatch);
}

export {
  getMentorshipActionsStatsByVersionId,
  getMentorshipActionsStats,
  getTagText,
  getMentor,
  getSignatureState,
  getSignatureDerivedData,
  matchesUserOrOldID,
};
